import { render, staticRenderFns } from "./orderMargins.vue?vue&type=template&id=39c177b6&"
import script from "./orderMargins.vue?vue&type=script&lang=js&"
export * from "./orderMargins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports